import { User, getTokens } from './authStorage';

/**
 * Checks if the current user is an admin based on their email domain
 * @returns boolean indicating if the user has admin privileges
 */
export const isCurrentUserAdmin = (): boolean => {
  const { userData } = getTokens();
  return isUserAdmin(userData);
};

/**
 * Checks if a user is an admin based on their email domain
 * @param user - User object to check
 * @returns boolean indicating if the user has admin privileges
 */
export const isUserAdmin = (user: User | null): boolean => {
  if (!user?.email) {
    return false;
  }
  return user.email.endsWith('@wand.tech');
};